const STYLES = {
  new: "bg-white border border-[#E2DED0] text-[#1E3A2F]",
  reviewing: "bg-[#3B5A6B]/10 border border-[#3B5A6B]/40 text-[#284454]",
  hired: "bg-[#1E3A2F] text-[#DDA74A]",
  passed: "bg-[#F7F4EB] border border-[#E2DED0] text-[#5C5C5C]",
};

const LABELS = { new: "New", reviewing: "Reviewing", hired: "Hired", passed: "Passed" };

export default function StatusPill({ status = "new", className = "" }) {
  const cls = STYLES[status] || STYLES.new;
  const label = LABELS[status] || status;
  return (
    <span
      data-testid={`status-pill-${status}`}
      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium ${cls} ${className}`}
    >
      {label}
    </span>
  );
}

export const APPLICATION_STATUSES = ["new", "reviewing", "hired", "passed"];
